import i18n from '@/common/locales/i18n';
import type { NamespacedTranslationKey } from '@/common/types/i18n.types';

interface EdenError {
  value?: { message?: string };
  message?: string;
}

export function getEdenErrorMessage(error: unknown, fallbackKey: NamespacedTranslationKey): string {
  if (error && typeof error === 'object') {
    const edenError = error as EdenError;
    if (edenError.value?.message) return edenError.value.message;
    if (edenError.message) return edenError.message;
  }
  return i18n.t(fallbackKey);
}
